import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import './animations.css';
import Header from './components/Header';
import AboutMe from './components/AboutMe';
import Projects from './components/Projects';
import ToggleSwitch from './components/ToggleSwitch';

function App() {
  const [showProjects, setShowProjects] = useState(false);
  const [containerHeight, setContainerHeight] = useState('auto');
  const projectsRef = useRef(null);
  const aboutMeRef = useRef(null);

  const toggleComponent = () => {
    setShowProjects((prevShowProjects) => !prevShowProjects);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      const currentRef = showProjects ? projectsRef : aboutMeRef;
      if (currentRef.current) {
        setContainerHeight(`${currentRef.current.scrollHeight}px`);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [showProjects]);


  useEffect(() => {
    if (aboutMeRef.current) {
      setContainerHeight(`${aboutMeRef.current.scrollHeight}px`);
    }
  }, []);

  return (
    <div className="App">
      <Header />
      <ToggleSwitch onClick={toggleComponent} toggled={!showProjects} />
      <div className="component-container" style={{ height: containerHeight }}>
        <div
          className={`component-slider ${
            showProjects ? 'show-projects' : ''
          }`}
        >
          <div ref={projectsRef} className="component-wrapper">
            <Projects />
          </div>
          <div ref={aboutMeRef} className="component-wrapper">
            <AboutMe />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
